module.exports = __webpack_public_path__ + "img/portfolio-home.c8b86226.png";